import { FETCH_TRANSACTION_VALUES_SUCCESS, FETCH_TRANSACTION_VALUES_LOAD } from '../types';

const initialState = {
	period: '1D',
	totalValue: 0,
	pctChange: 0,
	trend: []
};

export default function transactionValues(state = initialState, action) {
	switch (action.type) {
		case FETCH_TRANSACTION_VALUES_LOAD:
			return {
				loading: true,
				...action.payload
			};
		case FETCH_TRANSACTION_VALUES_SUCCESS:
			return {
				loading: false,
				...action.payload
			};
		default:
			return state;
	}
}

export const getTransactionValues = (state) => state;
